import { formatDate } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { HttpService } from '../services/http.service';
import { HelperService } from '../services/helper.service';
import { Subscription } from 'rxjs';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-milestone',
  templateUrl: './milestone.component.html',
  styleUrl: './milestone.component.css',
})
export class MilestoneComponent implements OnInit, OnDestroy {
  @Input() milestoneList: any = {};
  @Input() isMyTask:boolean=false
  @Input() outcomeTitle:string=''
  @Input() timeline:any= {};
  @Output() notifyParent = new EventEmitter<string>();

  overAllGroupDataSubs!: Subscription;
  visible: boolean = false;
  dependencyModal: boolean = false;
  formGroup: FormGroup;
  selectedGroups: any = [];
  selectedGroupsMember: any = [];
  overAllGroupData: any = [];
  helperService = inject(HelperService);
  groupMemberList: any = [];
  toastService = inject(ToastService);
  isOpenTerminateModal: boolean=false;
  selectedGroup: any=null;
  selectedGroupMember: any=null;
  constructor(private fb: FormBuilder, private httpService: HttpService) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      quarterlyOutcome: [''],
      milestoneTitle: [''],
      start_date: [''],
      plan_end_date: [''],
      actual_end_date: [''],
    });
    this.formGroup.patchValue({
      quarterlyOutcome:this.outcomeTitle || '',
      milestoneTitle:this.milestoneList?.value || '',
      start_date: this.milestoneList?.start_date|| '',
      plan_end_date:this.milestoneList?.plan_end_date || '',
      actual_end_date: this.milestoneList?.actual_end_date|| '',
    })

    setTimeout(() => {
      this.formGroup
        .get('quarterlyOutcome')
        ?.setValue(this.outcomeTitle);
      this.formGroup.get('quarterlyOutcome')?.disable();
    }, 1000);

    this.overAllGroupDataSubs = this.helperService.overAllGroup$.subscribe(
      (res) => {
        this.overAllGroupData = res;
      }
    );
  }

  onGroupDataChange(searchTerm?: any): void {
    this.selectedGroupMember=null
    const currentSelection = this.selectedGroupMember;
    const requestData = {
      groups: this.selectedGroup?.group_id,
      search: searchTerm || '',
    };
  
    this.httpService.post(`${environment.opbBackendHost}/api/member/group/members`, requestData).subscribe(
      (response) => {
        this.groupMemberList = response?.data;

      // Filter out logged-in user and update the list
      this.groupMemberList = this.groupMemberList?.filter(
        (m: any) => m.user_id !== this.helperService.loggedInUser.user_id
      );

        if (currentSelection && !this.groupMemberList?.find((item:any) => item?.name == currentSelection?.name)) {
          this.groupMemberList.push(currentSelection);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }
  

  onGroupMemberChange(event:any){
    this.selectedGroupMember=event?.value
  }
  

  onGroupMemberSearchChange(event: any): void {
    this.onGroupDataChange(event?.filter);
  }

  

  closeDependeciesModal() {
    this.visible = false;
  }

  addDepencies(): void {
    // const selectedUserIds = this.selectedGroupsMember
    //   ?.map((member: any) => member.user_id)
    //   .join(',');

    let formatData = {
      milestone_id: this.milestoneList?.milestone_id,
      users: this.selectedGroupMember.user_id,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/milestones/add/dependencies`,
        {
          ...formatData,
        }
      )
      .subscribe(
        (response) => {
          this.overAllGroupData = response?.data;
          this.selectedGroups = [];
          this.selectedGroupsMember = [];
          response?.error
            ? this.toastService.error(response?.message)
            : this.toastService.success(response?.message);
          this.closeDependeciesModal();
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }

  onOverAllSearchChange(event?: any) {
    const currentSelection = this.selectedGroup; 
  
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/all/groups`, {
        search: event?.filter,
      })
      .subscribe(
        (response) => {
          this.overAllGroupData = response?.data;
  
          if (currentSelection && !this.overAllGroupData?.find((item:any) => item?.name === currentSelection?.name)) {
            this.overAllGroupData.push(currentSelection);
          }
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }
  

  formatDate(date: string | Date): any {
    if (!date || isNaN(new Date(date).getTime())) {
      return;
    }
    return formatDate(new Date(date), 'dd-MM-yyyy', 'en-US');
  }

  ngOnDestroy(): void {
    this.overAllGroupDataSubs?.unsubscribe();
  }

  onSubmit(): void {
    const formattedData = {
      milestone_id: this.milestoneList?.milestone_id,
      title: this.formGroup.value.milestoneTitle, 
      start_date: this.formatDate(this.formGroup.value.start_date),
      plan_end_date: this.formatDate(this.formGroup.value.plan_end_date),
      actual_end_date: this.formatDate(this.formGroup.value.actual_end_date),
    };
    this.updateMileStone(formattedData);
  }

  closeModal() {
    this.dependencyModal = false;
  }

  updateMileStone(data?: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/milestones/update`, { ...data })
      .subscribe({
        next: (response: any) => {
          response?.error
            ? this.toastService.error(response?.message)
            : this.toastService.success(response?.message);
  
          if (!response?.error) {
            this.notifyParent.emit();
          }
  
          this.closeModal(); 
        },
        error: (err: any) => {
          this.toastService.error('Internal Server Error');
          this.closeModal(); 
        },
      });
  }
  
  openTerminateModal() {
    this.isOpenTerminateModal = true;
  }

  closeTerminateModal() {
    this.isOpenTerminateModal = false;
  }

  terminateMileStone() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/milestones/terminate`, {
        milestone_id: this.milestoneList?.milestone_id,
      })
      .subscribe((response: any) => {
        response?.error
          ? this.toastService.error(response?.message)
          : this.toastService.success(response?.message);
          if(!response?.error){
            this.notifyParent.emit();
          }
          this.closeTerminateModal();
      });
  }

  getDefaultAvatar() {
    return this.helperService.defaultImageUrl;
  }

  addDependency() {
    this.onOverAllSearchChange();
    this.visible = true;
    this.selectedGroup=null
    this.selectedGroupMember=null
  }

  updateMilestone() {
    this.dependencyModal = true;
  }
  
}
